const rainPipesSettings = {
    frontAndBackIndentMeter: 0.54,
    distanceFromConcretePlinthMm: 80, // the distance from the heart of the pipe to the concrete plinth
    diameterMm: 79
}

export default rainPipesSettings
